import { services } from '../app/services.js';
import { AsyncDataPipeableArray } from '../base/pipeable/async_data_pipeable_array.js';

class FoodMenuFoods extends AsyncDataPipeableArray {
  getLoadPromise() {
    return services.trip.getFoods();
  }

  get dataClassName() {
    return 'food-menu-foods';
  }

  toString() {
    return `FoodMenuFoods`;
  }
}

export { FoodMenuFoods };
